// app : dead events - events with no instrinctive value
// page : user navigational events - page views
// Action : user specific actions - important.
export type HTTPRequestType =
  | 'post'
  | 'patch'
  | 'get'
  | 'delete'
  | 'put';
  
